import dayjs from 'dayjs';

function formatYear(year, format) {
  return dayjs(new Date(year, 1, 1)).format(format);
}

export { formatYear };
//# sourceMappingURL=format-year.js.map
